import { loadAndTrack } from "redux-request-loading";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";

import { Dispatch } from "../../store";
import { ACTION_TASK_SUCCESS } from "../../crud/ohCase/actiontypes";
import { OhCaseAction } from "../../crud/ohCase/actions";

import { SetRecallModel } from "./models";
import { recallApi } from "./recallApi";

export const CREATING_RECALLS = "CREATING_RECALLS";

export const createRecallsSuccess = (task: TaskModel): OhCaseAction => {
    return {
        type: ACTION_TASK_SUCCESS,
        payload: { ohCaseId: task.caseId, tasks: [task] }
    };
};

export const createRecalls = (customerId: string, ohCaseId: string, taskId: string, model: SetRecallModel[]) => async (dispatch: Dispatch) => {
    const updatedTask = await loadAndTrack(dispatch, CREATING_RECALLS, recallApi.setRecalls(customerId, ohCaseId, taskId, model));
    dispatch(createRecallsSuccess(updatedTask));
};
